import { isNullOrWhiteSpace, reject } from "../../../../../Common/TypingUtils";

import { TaxRebateItemLawPattern } from "./TaxRebate";

interface TaxRebateValuePart {
    rawValue: undefined | string;
    value: undefined | string;
    start: number;
    end: number;
}

export interface TaxRebateValueInfo {
    code: TaxRebateValuePart;
    law1: undefined | TaxRebateValuePart;
    law2: undefined | TaxRebateValuePart;
    law3: undefined | TaxRebateValuePart;
}

function trimLeadingZeros(law: string): string {
    return law.replace(/^0*/, "");
}

function getLaws(laws: string, lawPattern: TaxRebateItemLawPattern) {
    const { law1Length, law2Length, law3Length, law2Delimiter, law3Delimiter } = lawPattern;
    const law1End = law1Length > 0 ? law1Length : 0;
    const law2Start = law1End > 0 ? law1End + law2Delimiter.length : law1End;
    const law2End = law2Start > 0 && law2Length > 0 ? law2Start + law2Length : 0;
    const law3Start = law2End > 0 ? law2End + law3Delimiter.length : 0;
    const law3End = law3Start > 0 && law3Length > 0 ? law3Start + law3Length : 0;
    const law1 = law1End > 0 ? laws.slice(0, law1End) : "";
    const law2 = law2End > 0 ? laws.slice(law2Start, law2End) : "";
    const law3 = law3End > 0 ? laws.slice(law3Start, law3End) : "";
    return { law1: law1, law2: law2, law3: law3 };
}

export function splitTaxRebateValue(value: string, lawPattern: TaxRebateItemLawPattern): TaxRebateValueInfo {
    const { law1Delimiter, law2Delimiter, law3Delimiter } = lawPattern;
    const taxRebateWithLaws = new RegExp("^(.*?)\\" + law1Delimiter + "(.+)$");
    const taxRebateWithEmptyLaws = new RegExp("^(.*?)\\" + law1Delimiter + "$");
    const taxRebateWithLawsMatch = taxRebateWithLaws.exec(value);

    if (taxRebateWithLawsMatch) {
        const [_, code = reject(), laws = reject()] = taxRebateWithLawsMatch;
        const result: TaxRebateValueInfo = {
            code: { value: code, rawValue: code, start: 0, end: code.length },
            law1: undefined,
            law2: undefined,
            law3: undefined,
        };
        const { law1, law2, law3 } = getLaws(laws, lawPattern);

        const law1Start = code.length + law1Delimiter.length;
        const law1End = law1Start + law1.length;
        const law2Start = law1End + law2Delimiter.length;
        const law2End = law2Start + law2.length;
        const law3Start = law2End + law3Delimiter.length;
        const law3End = law3Start + law3.length;

        if (!isNullOrWhiteSpace(law1)) {
            result.law1 = {
                value: trimLeadingZeros(law1),
                rawValue: law1,
                start: law1Start,
                end: law1End,
            };
        }
        if (!isNullOrWhiteSpace(law2)) {
            result.law2 = {
                value: trimLeadingZeros(law2),
                rawValue: law2,
                start: law2Start,
                end: law2End,
            };
        }
        if (!isNullOrWhiteSpace(law3)) {
            result.law3 = {
                value: trimLeadingZeros(law3),
                rawValue: law3,
                start: law3Start,
                end: law3End,
            };
        }
        return result;
    }
    const taxRebateWithEmptyLawsMatch = taxRebateWithEmptyLaws.exec(value);
    if (taxRebateWithEmptyLawsMatch != undefined) {
        const [_, code = reject()] = taxRebateWithEmptyLawsMatch;
        const law1Start = code.length + law1Delimiter.length;
        const result: TaxRebateValueInfo = {
            code: { value: code, rawValue: code, start: 0, end: code.length },
            law1: {
                value: "",
                rawValue: "",
                start: law1Start,
                end: law1Start,
            },
            law2: undefined,
            law3: undefined,
        };
        return result;
    }
    return {
        code: { value: value, rawValue: value, start: 0, end: value.length },
        law1: undefined,
        law2: undefined,
        law3: undefined,
    };
}
